// eslint-disable-next-line consistent-default-export-name/default-export-match-filename
import React, { Fragment } from "react";
// eslint-disable-next-line consistent-default-export-name/default-import-match-filename
import ReactDOM from "react-dom/client";
import "react-day-picker/dist/style.css";
import "assets/scss/index.scss";
import "./bootstrap.ts";
import { Provider } from "react-redux";
import store, { useAppDispatch, useAppSelector } from "config/store";
import { RouterProvider } from "react-router-dom";
import router from "config/router.tsx";
import { globalActions } from "config/store/modules/global.ts";
import { authActions } from "config/store/modules/auth.ts";
import { useMount } from "react-use";
import ToastsPopup from "components/modals/automatics/ToastsPopup.tsx";

function MainInner() {
  const dispatch = useAppDispatch();
  const isAuthChecked = useAppSelector(state => state.auth.isCheck);

  //fetch globals on app init
  useMount(() => {
    dispatch(globalActions.getGlobals());
    dispatch(authActions.initAuthCheck());
  });

  if (!isAuthChecked) {
    return null;
  }

  return (
    <Fragment>
      <RouterProvider router={router} />
      {/*disabled for now  <AcceptCookiesPopup/> */}
      <ToastsPopup />
    </Fragment>
  );
}


function Main() {
  return (
    <React.StrictMode>
      <Provider store={store}>
        <MainInner />
      </Provider>
    </React.StrictMode>
  );
}

export default Main;

ReactDOM.createRoot(document.getElementById("root")!).render(<Main />);
